export default ({ request }) => ({
  mrpSalesStockOutListApi(data = {}) {
    return request({
      url: '/factory/mrp/sales/stockOut/list',
      method: 'post',
      data,
    })
  },
  mrpSalesStockOutDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/sales/stockOut/detail',
      method: 'post',
      data,
    })
  },
  mrpSalesStockOutSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/sales/stockOut/save',
      method: 'post',
      data,
    })
  },
  mrpSalesStockOutDelApi(data = {}) {
    return request({
      url: '/factory/mrp/sales/stockOut/del',
      method: 'post',
      data,
    })
  },
  mrpSalesStockOutSubmitApi(data = {}) {
    return request({
      url: '/factory/mrp/sales/stockOut/submit',
      method: 'post',
      data,
    })
  },
})
